<template>
  <div
    class="ma-0 mx-auto"
    style="min-height: 100%; max-width: 1000px;"
  >
    <v-card
      style="max-width: 700px; position: relative;"
      class="mx-auto py-2"
    >
      <v-btn
        v-if="filteredRentals && filteredRentals.length > 0 && false"
        color="accent"
        style="position: absolute; right: 10px; top: 10px; min-width: 35px; width: 35px; height: 35px;"
        @click="downloadCSV()"
      >
        <v-icon>mdi-download</v-icon>
      </v-btn>

      <h2
        class="mb-5"
      >My {{ env.rentalWord }}s</h2>

      <v-autocomplete
        v-model="property_id"
        :items="propertyItems"
        label="Property"
        class="px-5 mb-3"
        hide-details
        dense
        outlined
      />

      <div
        class="d-flex align-center justify-space-around flex-wrap"
        style="width: 100%;"
      >
        <div
          class="d-flex align-center mb-3"
          style="width: 350px;"
        >
          <span
            class="pl-5 pr-3"
            style="width: 110px; text-align: left;"
          >Start Date:</span>

          <v-text-field
            v-model="startDate"
            type="date"
            class="pr-5"
            style="width: 200px"
            dense
            outlined
            hide-details
            :rules="[
              v => !!v || 'Start date is required',
              v => new Date(v).getTime() <= new Date(this.endDate).getTime() || 'Start date must be before end date',
            ]"
          />
        </div>

        <div
          class="d-flex align-center mb-3"
          style="width: 350px;"
        >
          <span
            class="pl-5 pr-3"
            style="width: 110px; text-align: left"
          >End Date:</span>

          <v-text-field
            v-model="endDate"
            type="date"
            class="pr-5"
            style="width: 200px"
            dense
            outlined
            hide-details
            :rules="[
              v => !!v || 'End date is required',
              v => new Date(v).getTime() >= new Date(this.startDate).getTime() || 'End date must be after start date',
            ]"
          />
        </div>
      </div>

      <v-expansion-panels
        v-if="filteredRentals && filteredRentals.length > 0"
        :key="filteredRentals.length"
        class="mx-auto px-0"
        popout
        flat
        tile
        hover
      >
        <v-expansion-panel
          v-for="(r, i) in filteredRentals"
          :key="'payment' + i"
          class="mb-1"
          readonly
        >
          <v-expansion-panel-header
            color="#E6E6E6"
            class="d-flex align-center justify-center flex-wrap"
            style="position: relative; min-height: 60px;"
            disable-icon-rotate
            hide-actions
          >
            <div
              style="position: absolute; left: 0; top: 0; width: 100%; height: 100%;"
              @click="gotoRentalForm(r)"
            ></div>

            <div v-if="clientWidth > 600" class="d-flex align-center justify-space-between" style="column-gap: 10px;">
              <v-icon
                v-if="new Date(r.check_out) >= midnight"
                style="position: absolute; top: 10px; right: 10px; cursor: pointer;"
                @click="gotoRentalForm(r)"
              >mdi-pencil</v-icon>

              <span><b>{{ r.lname }} {{ r.line1 }}</b>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ convertDate(r.check_in) }} - {{ convertDate(r.check_out) }}</span>

              <v-btn
                v-if="env.rentalPayIndividual && new Date(r.check_out) < midnight && r.payment_id == null && r.amount > 0"
                color="green"
                dark
                small
                class="ma-0 pa-0"
                style="min-width: 100px !important; max-width: 100px !important; width: 0px !important;"
                @click="gotoPayment(r)"
              >Pay Now</v-btn>
            </div>
            <div v-else class="d-flex flex-column align-center" style="row-gap: 10px;">
              <v-icon
                v-if="new Date(r.check_out) >= midnight"
                style="position: absolute; top: 10px; right: 10px; cursor: pointer;"
                @click="gotoRentalForm(r)"
              >mdi-pencil</v-icon>

              <span><b>{{ r.lname }} {{ r.line1 }}</b></span>
              <span>{{ convertDate(r.check_in) }} - {{ convertDate(r.check_out) }}</span>

              <v-btn
                v-if="env.rentalPayIndividual && new Date(r.check_out) < midnight && r.payment_id == null && r.amount > 0"
                color="green"
                dark
                small
                class="ma-0 pa-0"
                style="min-width: 100px !important; max-width: 100px !important; width: 0px !important;"
                @click="gotoPayment(r)"
              >Pay Now</v-btn>
            </div>


          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels>

      <div
        v-else-if="rentals && rentals.length > 0"
        class="d-flex flex-column align-center pa-3 mx-auto"
        style="width: 400px; max-width: 100%;"
      >
        <h4>You have no {{ env.rentalWord.toLowerCase() }}s in this time range for the selected propert{{ this.property_id === 'all' ? 'ies' : 'y' }}.</h4>
      </div>

      <div
        v-else-if="!loading"
        class="d-flex flex-column align-center pa-3 mx-auto"
        style="width: 400px; max-width: 100%;"
      >
        <h4>You have no {{ env.rentalWord.toLowerCase() }} history.</h4>

        <v-btn
          color="accent"
          class="mx-auto mt-3"
          style="min-width: 150px;"
          @click="$router.back()"
        >
          <v-icon
            class="mr-1"
          >mdi-arrow-left</v-icon>

          <span>Back</span>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Payments',

  components: {

  },

  props: {
    env: {
      type: Object,
      required: true,
    },

    permissions: {
      type: Number,
      required: true,
    },

    properties: {
      type: Array,
      required: true,
    },

    rentals: {
      type: Array,
      required: true,
    },

    propList: {
      type: Array,
      required: true,
      default: [],
    },

    loading: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    filteredRentals: [],
    property_id: null,
    propertyItems: [],
    months: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    startDate: null,
    endDate: null,
    clientWidth: 0,
  }),

  computed: {
    midnight() {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      return d;
    },
  },

  watch: {
    propList() {
      this.populatePropertyItems();
    },

    property_id() {
      if (this.$route.query.property != this.property_id) {
        this.$router.replace({ query: { property: this.property_id, start: this.startDate, end: this.endDate } });
      }
      this.filterRentals();
    },

    rentals() {
      this.filterRentals();
    },

    startDate() {
      this.filterRentals();
      if (this.$route.query.start != this.startDate) {
        this.$router.replace({ query: { property: this.property_id, start: this.startDate, end: this.endDate } });
      }
    },

    endDate() {
      this.filterRentals();
      if (this.$route.query.end != this.endDate) {
        this.$router.replace({ query: { property: this.property_id, start: this.startDate, end: this.endDate } });
      }
    },
  },

  methods: {
    populatePropertyItems() {
      this.propertyItems = [{
        text: 'All',
        value: 'all',
      }];

      for (const p of this.propList) {
        this.propertyItems.push(p);
      }
    },

    filterRentals() {
      if (this.property_id === 'all') {
        this.filteredRentals = this.rentals.filter(f => new Date(f.check_in).getTime() >= new Date(this.startDate).getTime() && new Date(f.check_in).getTime() <= new Date(this.endDate).getTime());
      }
      else {
        this.filteredRentals = this.rentals.filter(f => f.property_id === this.property_id && new Date(f.check_in).getTime() >= new Date(this.startDate).getTime() && new Date(f.check_in).getTime() <= new Date(this.endDate).getTime());
      }
    },

    convertDate(d) {
      const d2 = new Date();
      d2.setFullYear(parseInt(d.slice(0, 4)), parseInt(d.slice(5, 7)) - 1, parseInt(d.slice(8, 10)));
      d2.setHours(0, 0, 0);
      return d2.toDateString().slice(4);
    },

    gotoRentalForm(r) {
      if (r === undefined) {
        return '/dashboard/' + this.$route.path.match(/member|manager/i)[0] + '/rental-form';
      }
      else {
        this.$router.push('/dashboard/' + this.$route.path.match(/member|manager/i)[0] + '/rental-form/' + r.id);
      }
    },

    gotoPayment(r) {
      if (r !== undefined) {
        this.$router.push('/dashboard/' + this.$route.path.match(/member|manager/i)[0] + '/payment/?type=single-rental&property_id=' + r.property_id + '&id=' + r.id);
      }
    },

    downloadCSV() {
      let csv = '\uFEFF'; // Universal Byte Order Mark (BOM)

      // Populate headers
      Object.keys(this.filteredRentals[0]).forEach((key) => {
        csv += key + ','
      });
      csv = csv.slice(0, -1) + '\r\n';

      // Populate data
      for (const rental of this.filteredRentals) {
        Object.keys(rental).forEach((key) => {
          if (rental[key] && rental[key].type === 'list') {
            let a = Array();
            rental[key].forEach((item) => {
              let s = '';
              Object.keys(item).forEach((key2) => {
                s += item[key2] + ' ';
              })
              a.push(s.slice(0, -1));
            });
            csv += JSON.stringify(a) + ','
          }
          else
            csv += rental[key] + ','
        });
        csv = csv.slice(0, -1) + '\r\n';
      }

      // Create file and trigger download
      let e = document.createElement('a');
      e.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      e.target = '_blank';
      e.download = `rentals-${this.propertyItems.filter((e) => { return e.value === this.property_id })[0].text.replace(/0x20/gi, '_')}.csv`;
      e.click();
    },

    onresize () {
      this.clientWidth = document.body.clientWidth;
    },
  },

  destroyed () {
    window.removeEventListener('resize', this.onresize, false);
  },

  created () {
    this.onresize();
    window.addEventListener('resize', this.onresize, false);

    this.populatePropertyItems();

    if (parseInt(this.$route.query.property)) {
      this.property_id = parseInt(this.$route.query.property);
    }
    else {
      this.property_id = 'all';
    }

    if (this.$route.query.start) {
      this.startDate = this.$route.query.start;
    }
    else {
      let d = new Date();
      d.setMonth(d.getMonth() - 1);
      this.startDate = d.toISOString().slice(0, 10);
    }

    if (this.$route.query.end) {
      this.endDate = this.$route.query.end;
    }
    else {
      let d = new Date();
      d.setMonth(d.getMonth() + 1);
      this.endDate = d.toISOString().slice(0, 10);
    }

    this.filterRentals();
  },
};
</script>

<style>

</style>
